
import {map} from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Execution } from './execution';
import { Apollo } from 'apollo-angular';

const ExecutionQuery = require('./gql/execution.query.gql');
const createExecutionMutation = require('./gql/create-execution.mutation.gql');
const updateExecutionMutation = require('./gql/update-execution.mutation.gql');

/**
 * Service to manage executions
 */
@Injectable()
export class ExecutionService {

  constructor(private apollo: Apollo) { }

  execution(id: string): Observable<Execution> {
    return this.apollo
      .query({
        query: ExecutionQuery,
        variables: {
          id
        },
        fetchPolicy: 'network-only'
      }).pipe(
      map(result => new Execution(result.data['execution'])));
  }

  create(execution: Execution): Observable<Execution> {
    return this.apollo
      .mutate({
        mutation: createExecutionMutation,
        variables: {
          input: execution.toCreateExecutionInput()
        }
      }).pipe(
      map(result => new Execution(result.data['createExecution'])));
  }

  update(id: string, execution: Execution): Observable<Execution> {
    return this.apollo
      .mutate({
        mutation: updateExecutionMutation,
        variables: {
          id,
          input: execution.toUpdateExecutionInput()
        }
      }).pipe(
      map(result => new Execution(result.data['updateExecution'])));
  }
}